import { Button, styled } from '@mui/material';

export const StyledApplyButton = styled(Button)(({ theme }) => ({
   '&': {
      borderColor: theme.palette.text.primary,
      color: theme.palette.text.primary,
   },
}));
